import { useContext } from 'react'
import { mdiFolderOutline } from '@mdi/js'

import JobInfoHeaderMenu from './JobInfoHeaderMenu'
import { JobPageContext } from 'features/jobs/JobPageContext'
import usePermissions from 'features/auth/permissions/usePermissions'
import { DOMAIN_ADMIN } from 'features/auth/permissions/consts'
import {
  JobHeaderLeft,
  JobHeaderRight,
  JobHeaderTitle,
  JobHeaderTitleContainer,
  StyledJobHeader,
  JobHeaderIcon,
} from './styles'

function JobInfoHeader() {
  const { jobName, hasHomes, parentDomainId } = useContext(JobPageContext)
  const [grantAccessToRenameDeleteJob] = usePermissions({
    allow: [DOMAIN_ADMIN],
    domainId: parentDomainId,
  })
  const showJobInfoHeaderMenu = !hasHomes || grantAccessToRenameDeleteJob
  return (
    <StyledJobHeader>
      <JobHeaderLeft>
        <JobHeaderIcon path={mdiFolderOutline} size={1.7} />
        <JobHeaderTitleContainer>
          <JobHeaderTitle>{jobName}</JobHeaderTitle>
        </JobHeaderTitleContainer>
      </JobHeaderLeft>
      <JobHeaderRight>
        {showJobInfoHeaderMenu && <JobInfoHeaderMenu />}
      </JobHeaderRight>
    </StyledJobHeader>
  )
}

export default JobInfoHeader
